/**
 * Takes n number of items from an array.
 *
 * If last argument is omitted, starts at 0
 *
 *
 * @param array
 * @param n - number of elements to take
 * @param from - index to start from (optional)
 */
export function take<T>(array: T[], n: number, from = 0) {
  return array.slice(from, from + n);
}

export function takeLast<T>(array: T[], n: number) {
  return array.slice(-n);
}
